export default class DetailHeader {
    static init(): void {
        this.colorVariantExpand();
        this.detailHeaderSliderExpand();
    }

    static colorVariantExpand(): void {
        // Funkce pro toggle zobrazení itemů
        const initItemToggle = (): void => {
            const trigger = document.querySelector<HTMLElement>('.js-detail-header-color-trigger');
            const container = document.querySelector<HTMLElement>('.detail-header-color__grid');
            const closer = document.querySelector<HTMLElement>('.js-detail-header-color-closer');

            // Kontrola existence elementů
            if (!trigger || !container || !closer) {
                return; // Tiše ukončí, pokud elementy neexistují
            }

            trigger.addEventListener('click', (): void => {
                // Zobraz všechny itemy
                container.classList.add('show-all');

                // Skryj trigger
                trigger.classList.add('is-not-active');
            });

            closer.addEventListener('click', (): void => {
                // Skryj všechny itemy
                container.classList.remove('show-all');

                // Zobraz trigger
                trigger.classList.remove('is-not-active');
            });
        };

        // Spuštění po načtení DOMu
        initItemToggle();
    }

    static detailHeaderSliderExpand(): void {
        // Funkce pro toggle zobrazení itemů
        const initControlsToggle = (): void => {
            const controlsTrigger = document.querySelector<HTMLElement>('.detail-header-slider__control-item--trigger');
            const controlsContainer = document.querySelector<HTMLElement>('.detail-header-slider__controls');

            // Kontrola existence elementů
            if (!controlsTrigger || !controlsContainer) {
                return; // Tiše ukončí, pokud elementy neexistují
            }

            controlsTrigger.addEventListener('click', (): void => {
                // Zobraz všechny itemy
                controlsContainer.classList.add('show-all');

                // Skryj trigger
                controlsTrigger.classList.add('is-not-active');
            });
        };

        // Spuštění po načtení DOMu
        initControlsToggle();
    }
}